<!-- RELAY OUTPUTS -->
@if (selectedControllers | getRelayOutputNumbers; as relayOutputNumbers) {
  @for (relayOutputNo of relayOutputNumbers; track $index; let ind = $index) {
    @if (
      selectedControllers
      | findProperty : Property.isRelayOutputStatus : updated : useHiddenFilter
      | getRelayOutputByNumber : relayOutputNo; as relayOutputStatusProps
      ) {
      <!--  RELAY OUTPUT STATUS -->
      <div>
        {{
        selectedControllers | getRelayOutputName : relayOutputNo | translate
        }}
      </div>
      <div class="width100 margin-bottom20" style="background-color: #efeded">
        @if (relayOutputStatusProps.length > 0) {
          <div
            class="font-size16 flex-row-center-v"
            style="margin-left: 8px; font-family: sans-serif"
            >
            <span style="margin-right: 5px">
              {{ relayOutputStatusProps | getRelayOutputStatusName | translate }}:
            </span>
          <ion-chip class="chip no-click" style="margin: 5px 0;" [outline]="true">
            <ion-label class="chip-label">
              {{ ((relayOutputStatusProps | propIsActive) ? "On" : "Off") | translate }}
            </ion-label>
          </ion-chip>
            <ion-icon
              class="clickable to-right margin-right20"
              name="sync-outline"
              style="font-size: 20px"
              (click)="syncRekuperator()"
              >
            </ion-icon>
          </div>
        }
        <!-- RELAY OUTPUT SELECTOR -->
        @if (
          selectedControllers | showRelayOutputSelector : relayOutputNo) {
          <div
            class="width100 flex-row-center-h"
            >
            <ion-button
              id="click-trigger-relayOutput{{ ind }}"
              class="width90 margin-bottom10 margin-top10"
              >
              @if (
                selectedControllers
                | getRelayOutputStatusState
                : relayOutputNo
                : updated; as relayOutputStatusState
                ) {
                {{ relayOutputStatusState | translate }}
              }
            </ion-button>
            <ion-popover
              trigger="click-trigger-relayOutput{{ ind }}"
              triggerAction="click"
              [showBackdrop]="false"
              keep-contents-mounted="true"
              >
              <ng-template>
                <ion-content>
                  <ion-list>
                    <!-- BY RENTED OR PRESENCE -->
                    <ion-list-header class="margin-left5">{{
                      "Choose operation mode" | translate
                    }}</ion-list-header>
                    @if (
                      selectedControllers
                      | findProperty
                      : Property.isRelayOutputByRentedOrPresence
                      : updated
                      : useHiddenFilter
                      | getRelayOutputByNumber
                      : relayOutputNo; as relayOutputByRentedOrPresence
                      ) {
                      @if (relayOutputByRentedOrPresence.length > 0) {
                        <ion-item
                          [button]="true"
                        (click)="
                          activateRelayOutputProp(
                            Property.isRelayOutputByRentedOrPresence,
                            1,
                            relayOutputNo
                          )
                        "
                          >
                          {{ "By rented" | translate }}
                        </ion-item>
                        <ion-item
                          [button]="true"
                        (click)="
                          activateRelayOutputProp(
                            Property.isRelayOutputByRentedOrPresence,
                            0,
                            relayOutputNo
                          )
                        "
                          >
                          {{ "By presence" | translate }}
                        </ion-item>
                      }
                    }
                    <!-- FORCE ON -->
                    @if (
                      selectedControllers
                      | findProperty
                      : Property.isRelayOutputForceOn
                      : updated
                      : useHiddenFilter
                      | getRelayOutputByNumber
                      : relayOutputNo; as relayOutputForceOnProps
                      ) {
                      @if (relayOutputForceOnProps.length > 0) {
                        <ion-item
                          [button]="true"
                        (click)="
                          activateRelayOutputProp(
                            Property.isRelayOutputForceOn,
                            1,
                            relayOutputNo
                          )
                        "
                          >
                          {{
                          relayOutputForceOnProps[0].name.split("|")[1]
                          ? (relayOutputForceOnProps[0].name.split("|")[1]
                          | translate)
                          : ("Force on" | translate)
                          }}
                        </ion-item>
                      }
                    }
                    <!-- FORCE OFF -->
                    @if (
                      selectedControllers
                      | findProperty
                      : Property.isRelayOutputForceOff
                      : updated
                      : useHiddenFilter
                      | getRelayOutputByNumber
                      : relayOutputNo; as relayOutputForceOffProps
                      ) {
                      @if (relayOutputForceOffProps.length > 0) {
                        <ion-item
                          [button]="true"
                        (click)="
                          activateRelayOutputProp(
                            Property.isRelayOutputForceOff,
                            1,
                            relayOutputNo
                          )
                        "
                          >
                          {{
                          relayOutputForceOffProps[0].name.split("|")[1]
                          ? (relayOutputForceOffProps[0].name.split("|")[1]
                          | translate)
                          : ("Force off" | translate)
                          }}
                        </ion-item>
                      }
                    }
                    <!-- AUTO MODE  -->
                    @if (
                      selectedControllers
                      | findProperty
                      : Property.isRelayOutputAutoMode
                      : updated
                      : useHiddenFilter
                      | getRelayOutputByNumber
                      : relayOutputNo; as relayOutputAutoModeProps
                      ) {
                      @if (relayOutputAutoModeProps.length > 0) {
                        <ion-item
                          [button]="true"
                        (click)="
                          activateRelayOutputProp(
                            Property.isRelayOutputAutoMode,
                            1,
                            relayOutputNo
                          )
                        "
                          >
                          {{
                          relayOutputAutoModeProps[0].name.split("|")[1]
                          ? (relayOutputAutoModeProps[0].name.split("|")[1]
                          | translate)
                          : ("Auto mode" | translate)
                          }}
                        </ion-item>
                      }
                    }
                  </ion-list>
                </ion-content>
              </ng-template>
            </ion-popover>
          </div>
        } @else {
          @if (
            selectedControllers
            | findProperty
            : Property.isRelayOutputByRentedOrPresence
            : updated
            : useHiddenFilter
            | getRelayOutputByNumber
            : relayOutputNo; as relayOutputByRentedOrPresenceProps
            ) {
            @if (relayOutputByRentedOrPresenceProps.length > 0) {
              <ion-item
                lines="none"
                class="item-background-color"
                >
                <ion-checkbox
                (click)="
                  toggleRelayOutputValue(
                    $event,
                    Property.isRelayOutputByRentedOrPresence,
                    relayOutputNo
                  )
                "
                  justify="start"
                  labelPlacement="end"
                  [checked]="relayOutputByRentedOrPresenceProps | propIsActive"
                  [disabled]="false"
                  ><span class="ion-text-wrap">
                  {{ ((relayOutputByRentedOrPresenceProps[0].name.split('|')[1]) | translate) ??( "By rented" | translate)  }}</span
                  >
                </ion-checkbox>
              </ion-item>
            }
          }
          @if (
            selectedControllers
            | findProperty : Property.isRelayOutputForceOn : updated : useHiddenFilter
            | getRelayOutputByNumber
            : relayOutputNo; as relayOutputForceOnProps
            ) {
            @if (relayOutputForceOnProps.length > 0) {
              <ion-item
                lines="none"
                class="item-background-color"
                >
                <ion-checkbox
                (click)="
                  toggleRelayOutputValue(
                    $event,
                    Property.isRelayOutputForceOn,
                    relayOutputNo
                  )
                "
                  justify="start"
                  labelPlacement="end"
                  [checked]="relayOutputForceOnProps | propIsActive"
                  [disabled]="false"
                  ><span class="ion-text-wrap">
                    {{ ((relayOutputForceOnProps[0].name.split('|')[1]) | translate) ??( "Force on" | translate)  }}
                  </span
                  >
                </ion-checkbox>
              </ion-item>
            }
          }
          @if (
            selectedControllers
            | findProperty : Property.isRelayOutputForceOff : updated : useHiddenFilter
            | getRelayOutputByNumber
            : relayOutputNo; as relayOutputForceOffProps
            ) {
            @if (relayOutputForceOffProps.length > 0) {
              <ion-item
                lines="none"
                class="item-background-color"
                >
                <ion-checkbox
                (click)="
                  toggleRelayOutputValue(
                    $event,
                    Property.isRelayOutputForceOff,
                    relayOutputNo
                  )
                "
                  justify="start"
                  labelPlacement="end"
                  [checked]="relayOutputForceOffProps | propIsActive"
                  [disabled]="false"
                  ><span class="ion-text-wrap">
                     {{ ((relayOutputForceOffProps[0].name.split('|')[1]) | translate) ??( "Force off" | translate)  }}
                 </span
                  >
                </ion-checkbox>
              </ion-item>
            }
          }
        }
        @if (
          selectedControllers
          | findProperty : Property.isRelayOutputInCooling : updated : useHiddenFilter
          | getRelayOutputByNumber
          : relayOutputNo; as relayOutputInCoolingProps
          ) {
          @if (relayOutputInCoolingProps.length > 0) {
            <ion-item
              lines="none"
              class="item-background-color"
              >
              <ion-checkbox
              (click)="
                toggleRelayOutputValue(
                  $event,
                  Property.isRelayOutputInCooling,
                  relayOutputNo
                )
              "
                justify="start"
                labelPlacement="end"
                [checked]="relayOutputInCoolingProps | propIsActive"
                [disabled]="false"
                ><span class="ion-text-wrap">
                  {{ ((relayOutputInCoolingProps[0].name.split('|')[1]) | translate) ??("In cooling" | translate)  }}
                </span
                >
              </ion-checkbox>
            </ion-item>
          }
        }
      </div>
    }
  }
}
